import { Error } from '@wix/wix-ui-icons-common/on-stage';
import { SectionNotification, SectionNotificationType } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { classes, st } from './notification.st.css';
export const Notification = ({ message, isError })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: st(classes.root, {
            error: isError
        })
    }, /*#__PURE__*/ React.createElement(SectionNotification, {
        className: classes.sectionNotification,
        type: SectionNotificationType.wired
    }, isError && /*#__PURE__*/ React.createElement(SectionNotification.Icon, {
        icon: /*#__PURE__*/ React.createElement(Error, null)
    }), /*#__PURE__*/ React.createElement(SectionNotification.Text, null, message)));
};

//# sourceMappingURL=index.js.map